export const hair_colours = [ //An array of each Colour hairstyle's ID and name.
  /* The first 21 colours appear in Fallout Shelter. */
  {
    id: 'colour1', //For hairstyles, append #vb_ to find id of div. 
    name: 'Tan' //Show name in textbox.
  },
  {
    id: 'colour2',
    name: 'Reddish Brown'
  },
  {
    id: 'colour3',
    name: 'Brown'    /* Harkness & Mr. Burke from F03. */
  },
  {
    id: 'colour4',
    name: 'Brownish gray'
  },
  {
    id: 'colour5',
    name: 'Deep gray'
  },
  {
    id: 'colour6',
    name: 'Silver-white'
  },
  {
    id: 'colour7',
    name: 'Light blonde'
  },
  {
    id: 'colour8',
    name: 'Medium gray'
  },
  {
    id: 'colour9',
    name: 'Natural brown'
  },
  {
    id: 'colour10',
    name: 'Light yellow'
  },
  {
    id: 'colour11',
    name: 'Light orange'
  },
  {
    id: 'colour12',
    name: 'Reddish orange'
  },
  {
    id: 'colour13',
    name: 'White'
  },
  {
    id: 'colour14',
    name: 'Firetruck Red'
  },
  {
    id: 'colour15',
    name: 'Orange'
  },
  {
    id: 'colour16',
    name: 'Yellow'
  },
  {
    id: 'colour17',
    name: 'Evergreen'
  },
  {
    id: 'colour18',
    name: 'Blueberry Hill'
  },
  {
    id: 'colour19',
    name: 'Russian Violet'
  },
  {
    id: 'colour20',
    name: 'Your Eminence'
  },
  {
    id: 'colour21',
    name: 'Artist\'s Purple'
  },

  /* The following colors are not in-game, but look nice so I included them. */
  {
    id: 'colour22',
    name: 'Nuka Quantum'
  },
  {
    id: 'colour23',
    name: 'Scarlet'
  },
  {
    id: 'colour24',
    name: 'Polynesian Blue'
  },
  {
    id: 'colour25',
    name: 'Bubblegum'
  },
  {
    id: 'colour26',
    name: 'Geiger Green'
  },
  {
    id: 'colour27',
    name: 'Chipped Ice'
  },
  {
    id: 'colour28',
    name: 'Fallout Blonde'
  }
]

// Fallout 4 colours:
// Auburn
// Bleached
// Blond
// Brown
// Chestnut Brown
// Cool Brown
// Dark Brown
// Deep Brown
// Deep Red
// Dirty Blond
// Ginger
// Golden Blond
// Gray
// Graying
// Jet Black
// Light Brown
// Platnum Blond
// Red
// Silver
// Steel Gray
// Warm Black
//     White

// Fallout 3 colours:
// Bleached
//     Brown
// Chocolate
// Platinum
// Cornsilk
// Suede
// Pecan
// Auburn
// Ginger
// Honey
// Gold
// Rosewood
//     Black
// Chestnut
// Steel
// Champagne